import AgoraRTC from 'agora-rtc-sdk-ng'
import { EventEmitter } from 'events'
import { getUUID, parse } from './tool'

AgoraRTC.setLogLevel(3)

// 主副视频具体配置
export const clientConfig = {
  mode: 'live',
  codec: 'vp8',
  role: 'host'
}

class TestNetwork extends EventEmitter {
  uplinkClient: any
  // 声音的定时器
  volmnInterval: any
  appId: any
  track: any
  allDevices: any
  // 使用的镜头
  cameras: any
  // 麦克风轨道
  mikeTrack: any
  // 视频轨道列表
  videoTrackList: Array<any>
  constructor() {
    super()
    this.uplinkClient = null
    this.appId = import.meta.env.VITE_APP_AGORA_APPID
    this.videoTrackList = []
  }

  public async init() {
    this.uplinkClient = AgoraRTC.createClient(clientConfig as any)
    this.track = await AgoraRTC.createMicrophoneAndCameraTracks().catch(() => {
      console.log('---创建音视频失败---')
    })
    console.log(this.appId)
    await this.uplinkClient.join(this.appId, getUUID(), null, null)
    await this.uplinkClient.publish(this.track).catch((e: any) => {
      console.error(e)
    })
    // 检测到镜头设备发生改变，检测到设备改变统一提示并刷新页面
    AgoraRTC.onCameraChanged = (info) => {
      // console.error('camera changed!', info.state, info.device)
      super.emit('onDeviceChanged', info)
    }
    // 检测到麦克风设备发生改变
    AgoraRTC.onMicrophoneChanged = (info) => {
      super.emit('onDeviceChanged', info)
    }
    // 检测到音频播放设备发生改变
    AgoraRTC.onPlaybackDeviceChanged = (info) => {
      super.emit('onDeviceChanged', info)
    }
  }

  // 获取网络信息
  public getNetWork() {
    this.uplinkClient.on('network-quality', (quality: any) => {
      // 网络质量
      super.emit('localNetWorkGetStats', {
        // 0：质量未知。1：质量极好。2：用户主观感觉和极好差不多，但码率可能略低于极好。3：用户主观感受有瑕疵但不影响沟通。4：勉强能沟通但不顺畅。5：网络质量非常差，基本不能沟通。6: 网络连接断开，完全无法沟通。
        downlink: quality.uplinkNetworkQuality,
        uplink: quality.downlinkNetworkQuality
      })
    })
  }

  // 获取硬件设备
  public async getDevices() {
    const devices = await AgoraRTC.getDevices().catch((err: any) => console.error(err))
    const audioInputDevices =
      devices &&
      devices.filter(function (device) {
        return device.kind === 'audioinput'
      })
    const videoDevices =
      devices &&
      devices.filter(function (device) {
        return device.kind === 'videoinput'
      })
    const audioOutputDevices =
      devices &&
      devices.filter(function (device) {
        return device.kind === 'audiooutput'
      })
    const allDevices = {
      videoDevices,
      audioOutputDevices,
      audioInputDevices
    }
    this.allDevices = allDevices
    return allDevices
  }

  // 播放视频
  public async playVideoTracks() {
    const devices = await this.getDevices()
    this.allDevices = devices
    const videoList = devices.videoDevices || []
    this.videoTrackList = []
    videoList.forEach(async (item: any, index: number) => {
      // if (index === 0) {
      const videoTrack = await AgoraRTC.createCameraVideoTrack({
        cameraId: item.deviceId
      }).catch((err: any) => console.error(err))
      const dom = document.querySelector(`#camera-img${item.deviceId}`)
      if (dom) {
        const childNodes = dom.childNodes.length
        if (childNodes < 2) {
          videoTrack && videoTrack.play(`camera-img${item.deviceId}`)
        }
      }
      this.videoTrackList.push(videoTrack)
      // }
    })
  }

  // 获取摄像头
  public getCameras() {
    this.cameras = parse(localStorage.getItem('usableCameras')) || [] // 所有选中的镜头
    return this.cameras
  }

  // 设置镜头
  public setCameras(arrCameras: any) {
    this.cameras = arrCameras
    localStorage.setItem('usableCameras', JSON.stringify(arrCameras))
  }

  // 离开时调用
  public async leave() {
    try {
      const res = await this.uplinkClient.leave()
      super.removeAllListeners()
      this.track &&
        this.track.map(async (item: any) => {
          await item.setEnabled(false)
        })
      this.videoTrackList &&
        this.videoTrackList.map(async (item: any) => {
          await item.setEnabled(false)
          return true
        })
    } catch (e) {
      console.error(e)
      return false
    }
  }

  // 创建音频轨道并获取麦克风音量大小
  public async getVolume() {
    const micList = this.allDevices.audioInputDevices || (await this.getDevices()).audioInputDevices
    this.mikeTrack = await AgoraRTC.createMicrophoneAudioTrack({
      AEC: true, // 是否开启回声消除
      AGC: true, // 是否开启自动增益
      ANS: true, // 是否开启噪声抑制：
      microphoneId: micList[0].deviceid
    })
    // localStorage.setItem('usableMic', JSON.stringify(micList[0]));
    // TODO 修改
    // localStorage.setItem('usableMic', JSON.stringify(micList));
    this.volmnInterval = setInterval(() => {
      super.emit('eventDevicesVolu', Math.floor(this.mikeTrack.getVolumeLevel() * 100))
    }, 500)
  }
}

export const DeviceTestClass = TestNetwork

export default new TestNetwork()
